import defaultPosition from "@/helpers/wc/positionSettings";

export const visitorsCustomListSettings = {
  title: 'Custom Visitors List',
  name: 'visitorsCustomListBase',

  styles: defaultPosition,

  properties: {
    css: {
      table: {
        borderColor: 'grey',
        borderWidth: '2px'
      },
      header: {
        fontFamily: "Arial",
        fontSize: '20px',
        color: 'black',
        backgroundColor: 'white',
        textAlign: 'center',
        height: '50px',
        borderBottomColor: 'grey',
        borderBottomWidth: '2px',
        padding: '2px'
      },
      body: {
        fontFamily: "Arial",
        fontSize: '16px',
        color: 'black',
        backgroundColor: 'white'
      },
      row: {
        borderBottomColor: 'grey',
        borderBottomWidth: '1px',
      },
      cell: {
        height: '30px',
        justifyContent: 'center',
        borderTopColor: 'grey',
        borderTopWidth: '1px',
        borderBottomColor: 'grey',
        borderBottomWidth: '1px',
        padding: '2px'
      }
    }
  },
  cssLegend: {
    table: {
      borderColor: {
        type: 'color',
        name: 'borderColor'
      },
      borderWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      },
    },
    header: {
      name: 'tableHeader',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
      textAlign: {
        type: 'align',
        name: 'align'
      },
      height: {
        type: 'int',
        name: 'height',
        handler: val => val + 'px'
      },
      borderBottomColor: {
        type: 'color',
        name: 'borderColor'
      },
      borderBottomWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      },
      padding: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      }
    },
    body: {
      name: 'tableBody',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      }
    },
    row: {
      name: 'tableRow',
      borderBottomColor: {
        type: 'color',
        name: 'borderColor'
      },
      borderBottomWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      },
    },
    cell: {
      name: 'tableCells',
      justifyContent: {
        type: 'align',
        name: 'justifyContent'
      },
      height: {
        type: 'int',
        name: 'height',
        handler: val => val + 'px'
      },
      borderTopColor: {
        type: 'color',
        name: 'borderTopColor'
      },
      borderTopWidth: {
        type: 'int',
        name: 'borderTopWidth',
        handler: val => val + 'px'
      },
      borderBottomColor: {
        type: 'color',
        name: 'borderBottomColor'
      },
      borderBottomWidth: {
        type: 'int',
        name: 'borderBottomWidth',
        handler: val => val + 'px'
      },
      padding: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      }
    }
  }
};
